module.exports = __webpack_public_path__ + "image/demo_2_2_616a0.jpeg";